/**
 * Qué campo acompaña a cada tope del beneficio.
 *
 * Los dos topes son EXCLUYENTES: los cupos topean por cantidad y el monto por
 * plata, así que cada opción muestra SÓLO su campo y nunca los dos.
 *
 * Vive acá, con nombre y test propio, porque la regla ya se rompió una vez: la
 * condición estaba escrita en línea dentro del componente y quedó con el
 * criterio viejo ("cupos exige monto") cuando el resto del código pasó a
 * excluyente. `tsc` y la suite entera siguieron en verde —el backend guarda el
 * monto en null igual— y el error sólo se veía abriendo la pantalla.
 */
export function benefitCapFields(
  capType?: string,
): { showMaxAmount: boolean; showMaxQuota: boolean } {
  return {
    showMaxAmount: capType === 'amount',
    showMaxQuota: capType === 'quota',
  };
}
